import React from 'react';
import connectToStores from 'alt-store-connect';
import Sidebar from '../sidebar';
import FlowStore from '../../stores/flow';
import classnames from 'classnames';

import { getElements } from '../../config/elements';
import { getFlag } from '../../config/flags';
import { Glyphicon, OverlayTrigger, Popover } from 'react-bootstrap';
import { MAP_ELEMENT_TYPES } from '../../constants';
import { COLOUR_MAPPINGS } from '../graph/elements/elementStyles';

@connectToStores
class FlowSidebar extends React.Component {

    static getStores() {
        return [FlowStore];
    }

    static getPropsFromStores() {
        return {
            flow: FlowStore.getState(),
        };
    }

    elelmentTooltips = () => (
        new Map(
            this.props.flow.elements.filter(element => element.tooltip)
                .map(element => (
                    [
                        element.name,
                        <Popover
                            id={element.tooltip.title}
                            className="sidebar-popover"
                        >
                            <h5>{element.tooltip.title}</h5>
                            <div className="popover-content-body">
                                {element.tooltip.content}
                            </div>
                        </Popover>]
                )),
        )
    );

    render() {

        const { config } = this.props.flow.flows[this.props.flowId];


        const items = getFlag('canvas') ?
            getElements().map((element) => {
                let itemClasses = config ? 'sidebar-element disabled no-select new-canvas' : 'sidebar-element no-select new-canvas';
                if (element.isBeta) {
                    itemClasses = `${itemClasses} beta`;
                }

                const Icon = element.icon;

                return element.display && (
                    <OverlayTrigger
                        key={element.id}
                        rootClose
                        trigger={['hover', 'focus']}
                        placement="right"
                        overlay={this.elelmentTooltips().get(element.name)}
                        container={document.querySelector('#manywho-draw')}
                    >
                        <li
                            id={element.id}
                            data-flow={element.flow}
                            data-name={element.id}
                            data-style={element.style}
                            className={itemClasses}
                        >
                            <span className="backdrop" style={{ background: COLOUR_MAPPINGS[element.id] }}>
                                {typeof Icon === 'string' ? // Some of our icons are glyphicons.. whilst others might be svg
                                    <Glyphicon glyph={Icon} /> : 
                                    <span className="glyphicon"><Icon /></span>
                                }
                            </span>
                            <span>
                                {element.name}
                            </span>
                        </li>
                    </OverlayTrigger>
                );
            }) :
            getElements().filter(element => element.id !== MAP_ELEMENT_TYPES.group && element.id !== MAP_ELEMENT_TYPES.note).map((element) => {
                let itemClasses = config ? 'sidebar-element disabled no-select' : 'sidebar-element no-select';
                if (element.isBeta) {
                    itemClasses = `${itemClasses} beta`;
                }

                return element.display && (
                    <OverlayTrigger
                        key={element.id}
                        rootClose
                        trigger={['hover', 'focus']}
                        placement="right"
                        overlay={this.elelmentTooltips().get(element.name)}
                        container={document.querySelector('#manywho-draw')}
                    >
                        <li
                            id={element.id}
                            data-flow={element.flow}
                            data-name={element.id}
                            data-style={element.style}
                            className={itemClasses}
                            style={{ background: element.background }}
                        >
                            <Glyphicon glyph={element.icon} />
                            <span>
                                {element.name}
                            </span>
                        </li>
                    </OverlayTrigger>
                );
            });


        const className = classnames({
            'flow-sidebar': true,
            hidden: !this.props.isActive,
        });

        return <Sidebar ref={this.props.sideBarRef} class={className}>{items}</Sidebar>;
    }
}

export default FlowSidebar;
